export const SET_HRES7DE_INDEX_DISP = 'SET_HRES7DE_INDEX_DISP'
export const GET_HRES7DE_INDEX_DISP = 'GET_HRES7DE_INDEX_DISP'
export const SET_HRES7DE_DETAIL_DISP = 'SET_HRES7DE_DETAIL_DISP'
export const GET_HRES7DE_DETAIL_DISP = 'GET_HRES7DE_DETAIL_DISP'
export const TOGGLE_HRES7DE_PAGE = 'TOGGLE_HRES7DE_PAGE'
export const SET_HRES7DE_COLUMNS = 'SET_HRES7DE_COLUMNS'
export const GET_HRES7DE_COLUMNS = 'GET_HRES7DE_COLUMNS'
export const SET_HRES7DE_LABELS = 'SET_HRES7DE_LABELS'
export const GET_HRES7DE_LABELS = 'GET_HRES7DE_LABELS'
export const GET_HRES7DE_MAX_ROWSPAN = 'GET_HRES7DE_MAX_ROWSPAN'
export const RECEIVED_HRES7DE_COLUMNS_LABELS = 'RECEIVED_HRES7DE_COLUMNS_LABELS'
export const SET_HRES7DE_INDEX = 'SET_HRES7DE_INDEX'
export const GET_HRES7DE_INDEX = 'GET_HRES7DE_INDEX'
export const SET_HRES7DE_INDEX_SELECTED = 'SET_HRES7DE_INDEX_SELECTED'
export const GET_HRES7DE_INDEX_SELECTED = 'GET_HRES7DE_INDEX_SELECTED'
export const POST_HRES7DE_TAB1_SAVE = 'POST_HRES7DE_TAB1_SAVE'
export const POST_HRES7DE_TAB2_SAVE = 'POST_HRES7DE_TAB2_SAVE'
export const POST_HRES7DE_TAB3_POPUP_SAVE = 'POST_HRES7DE_TAB3_POPUP_SAVE'
export const POST_HRES7DE_TAB4_SAVE = 'POST_HRES7DE_TAB4_SAVE'
export const POST_HRES7DE_INDEX_CANCEL = 'POST_HRES7DE_INDEX_CANCEL'
export const RECEIVED_HRES7DE_INDEX = 'RECEIVED_HRES7DE_INDEX'
export const SET_HRES7DE_DETAIL = 'SET_HRES7DE_DETAIL'
export const GET_HRES7DE_DETAIL = 'GET_HRES7DE_DETAIL'
export const RECEIVED_HRES7DE_DETAIL = 'RECEIVED_HRES7DE_DETAIL'
export const SET_HRES7DE_DETAIL_TAB1_POPUP = 'SET_HRES7DE_DETAIL_TAB1_POPUP'
export const GET_HRES7DE_DETAIL_TAB1_POPUP = 'GET_HRES7DE_DETAIL_TAB1_POPUP'
export const RECEIVED_HRES7DE_DETAIL_TAB1_POPUP = 'RECEIVED_HRES7DE_DETAIL_TAB1_POPUP'
export const GET_HRES7DE_DETAIL_TAB3_SELECTED = 'GET_HRES7DE_DETAIL_TAB3_SELECTED'
export const SET_HRES7DE_DETAIL_TAB3_SELECTED = 'SET_HRES7DE_DETAIL_TAB3_SELECTED'
export const GET_HRES7DE_DETAIL_TAB3_POPUP = 'GET_HRES7DE_DETAIL_TAB3_POPUP'
export const SET_HRES7DE_DETAIL_TAB3_POPUP = 'SET_HRES7DE_DETAIL_TAB3_POPUP'
export const RECEIVED_HRES7DE_DETAIL_TAB3_POPUP = 'RECEIVED_HRES7DE_DETAIL_TAB3_POPUP'



// WEBPACK FOOTER //
// ./src/store/modules/hres7de/mutation-types.js